const urlApiAWS = 'https://g8hz84v042.execute-api.us-east-1.amazonaws.com/dev';
const urlApiLocal = 'http://localhost:3726'; //viv-appasesor-backend

const isLocal = false;

export default {
  isDebug: false,
  urlApiBase: isLocal ? urlApiLocal : urlApiAWS
}